import { KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';

const DRAG_ACTIVATION_DISTANCE_PX = 4;

// Not one PointerSensor: Chrome cancels the pointer stream when a touch becomes a scroll.
// Not a hold delay: it silently aborts the natural press-and-drag.
export default function useOptionReorder({ fields, move }) {
  const sensors = useSensors(
    useSensor(MouseSensor, { activationConstraint: { distance: DRAG_ACTIVATION_DISTANCE_PX } }),
    useSensor(TouchSensor, { activationConstraint: { distance: DRAG_ACTIVATION_DISTANCE_PX } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  );

  const handleDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;
    const from = fields.findIndex(field => field.id === active.id);
    const to = fields.findIndex(field => field.id === over.id);
    if (from >= 0 && to >= 0) move(from, to);
  };

  return { sensors, handleDragEnd };
}
